var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"routine-container"},[_c('left-container'),_c('center-container'),_c('right-container')],1)}
var staticRenderFns = []

export { render, staticRenderFns }